import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/Category/categoryContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/error-fetch-page.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/Footer/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/Header/announcementsList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/Header/header-client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/hover-prefetch-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/no-ssr.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/normal-page-active-column.jsx");
